/**
 * BrandMark — canonical Freeze Dry Academy logo lockup.
 *
 * The uploaded logo already contains both the mark (book + snowflake + chart)
 * and the "FREEZE DRY ACADEMY" wordmark, so we render it as a single image
 * and skip the previously-paired lucide Zap + text span.
 *
 * Props:
 *   size         'sm' | 'md' | 'lg'   height preset (default 'md')
 *   onClick      handler              makes the mark keyboard-focusable
 *   subtitle     string               optional eyebrow line below the logo
 *   className    string               extra wrapper classes
 *   showWordmark bool                 kept for API back-compat; the wordmark
 *                                     lives in the image itself, so this is
 *                                     effectively a no-op today
 */
import React from 'react';

const SIZE_MAP = {
  sm: 'h-9',
  md: 'h-12',
  lg: 'h-16',
};

const BrandMark = ({
  size = 'md',
  onClick,
  subtitle,
  className = '',
  testId = 'brand-mark',
}) => {
  const heightCls = SIZE_MAP[size] || SIZE_MAP.md;
  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center gap-3 ${onClick ? 'cursor-pointer group' : ''} ${className}`}
    >
      <img
        src="/brand-logo.png"
        alt="Freeze Dry Academy"
        className={`${heightCls} w-auto object-contain transition-transform ${onClick ? 'group-hover:scale-[1.02]' : ''}`}
        draggable={false}
      />
      {subtitle && (
        <span className="hidden md:block text-[10px] uppercase tracking-[0.2em] text-muted-foreground leading-tight max-w-[160px]">
          {subtitle}
        </span>
      )}
    </Tag>
  );
};

export default BrandMark;
